export default __webpack_public_path__ + "img/mastercard-1cc86ba6f3f646851ab6702794b0c036.png";